module.exports = {
    apiUrl: process.env.VUE_APP_API_URL,
    mediaUrl: process.env.VUE_APP_MEDIA_URL,
    sentryDsn: process.env.VUE_APP_SENTRY_DSN,
    websocketUrl: process.env.VUE_APP_WEBSOCKET_URL
};
